export const theme = {
  breakpoints: {
    mobile: 480,
    tablet: 768,
    laptop: 1000,
    all: Infinity
  },
  grid: {
    rowGap: 20,
    columnMargin: 20
  }
}
